import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: "root",
})
export class ConsentService {
    private readonly root = `/api/consent`;

    constructor(private http: HttpClient) {}

    recordConsent(userData: { phoneNumber: number; hasAcceptedConsent: boolean }) {
        return this.http.post(`${this.root}`, userData);
    }
}
